import React, { useState } from "react";
import ForgotPasswordProps from "./ForgotPasswordProps";
import {
    BodyText,
    CaptchaDisclaimer,
    InnerContainer,
    MailIllustration,
    StatusScreen,
    Title,
    Wrapper,
} from "@kaltura/mediaspace-shared-ui";
import ForgotPasswordFormContainer from "./ForgotPasswordFormContainer";
import { HtmlReactParser, translate } from "@kaltura/mediaspace-shared-utils";
import clsx from "clsx";

/**
 * forgot password page
 */
export function ForgotPassword({
    recapthcaMode,
    recaptchaSiteKey = "",
    recaptchaTheme = "light",
}: ForgotPasswordProps) {
    const [sent, setSent] = useState(false);
    const [error, setError] = useState<boolean>(false);

    const handleSubmit = () => {
        setSent(true);
    };

    const handleError = () => {
        setError(true);
    };

    return (
        <>
            {sent && (
                <StatusScreen
                    className="kms-ds-forgot-password-status"
                    image={MailIllustration}
                    title={translate("Reset password email was sent")}
                    text={translate(
                        "The reset-password email should appear shortly.<br>Make sure you check your spam folder."
                    )}
                    adjustVerticalPadding={true}
                />
            )}
            {!sent && (
                <Wrapper className={clsx("kms-ds-forgot-password", error && "error")}>
                    <InnerContainer adjustVerticalPadding={true} className={"kms-ds-forgot-password-inner"}>
                        <div>
                            <Title variant={"h2"} component={"h1"} className={"kms-ds-forgot-password-title"}>
                                {error ? translate("Something went wrong") : translate("Forgot Password")}
                            </Title>
                            <BodyText align={"center"} variant={"body1"} className={"kms-ds-forgot-password-text"}>
                                {HtmlReactParser(
                                    error
                                        ? translate(
                                              "The email you entered is marked for SSO (Single Sign On), please %1 login %2 first to start the registration process.",
                                              ["<a href='/user/login'>", "</a>"]
                                          )
                                        : translate(
                                              "Don't worry, it happens to the best of us. Fill in your email below and we'll send reset instructions."
                                          )
                                )}
                            </BodyText>
                            <div>
                                <ForgotPasswordFormContainer
                                    onSubmit={handleSubmit}
                                    recaptchaSiteKey={recaptchaSiteKey}
                                    recaptchaTheme={recaptchaTheme}
                                    recapthcaMode={recapthcaMode}
                                    onError={handleError}
                                />
                            </div>
                        </div>
                    </InnerContainer>
                    {recapthcaMode && recapthcaMode === "invisible" && <CaptchaDisclaimer />}
                </Wrapper>
            )}
        </>
    );
}

export default ForgotPassword;
